export default __webpack_public_path__ + "static/media/paymentMethodDiscover.0ecc0337.svg";